import { useQuery, gql } from '@apollo/client'

import { StoreOrderPayload } from '../../types'

import StoreOrder from '../modules/StoreOrder'

type Data = {
  fetchCompetingOffers: StoreOrderPayload[] | null
}
type Vars = {
  requestForQuoteId: string
  vendorId?: string
  vendorUserId?: string
}

const query = gql`
  query FetchCompetingOffers($requestForQuoteId: String!, $vendorId: ID, $vendorUserId: ID) {
    fetchCompetingOffers(
      requestForQuoteId: $requestForQuoteId
      vendorId: $vendorId
      vendorUserId: $vendorUserId
    ) {
      id
      insertedAt
      updatedAt
      timingDetails
      convenienceFeeRate
      salesTax {
        amount
        currency
      }
      discounts {
        percent
      }
      additionalCharges {
        id
        name
        price {
          amount
          currency
        }
      }
      lineItems {
        id
        quantity
        product {
          id
          name
          salePrice
        }
        unitPrice {
          amount
          currency
        }
        discountedUnitPrice {
          amount
          currency
        }
        extendedPrice {
          amount
          currency
        }
      }
      shippingAmount {
        amount
        currency
      }
    }
  }
`

const useCompetingOffers = (variables: Vars) => {
  const { refetch, loading, error, data } = useQuery<Data, Vars>(query, {
    variables: { ...variables },
    fetchPolicy: 'no-cache',
  })

  if (data && data.fetchCompetingOffers) {
    const competingOffers = data.fetchCompetingOffers.map(StoreOrder.fromPayload)
    return { refetch, loading, error, competingOffers }
  }

  return { refetch, loading, error, competingOffers: [] }
}

export default useCompetingOffers
